import {loadPyodide} from "pyodide";
import {consoleLogSingleton} from "../util/consoleLogUtils";

class PythonRunner {
	_pyodide: any = null;
	_onPyodideLoaded: Function[] = [];

	constructor() {
		const start = performance.now();
		loadPyodide({
			indexURL: "https://cdn.jsdelivr.net/pyodide/v0.27.5/full/",
			// These don't seem to work consistently - maybe only on initial load
			stderr: (text) => {
				consoleLogSingleton.enqueueLine(text + "\n");
			},
			stdout: (text) => {
				consoleLogSingleton.enqueueLine(text + "\n");
			},
		}).then((result) => {
			console.log("Pyodide loaded in", performance.now() - start);

			this._pyodide = result;
			this._onPyodideLoaded.forEach((callback) => callback());

			console.log(
				this._pyodide.runPython(`
            import sys
            sys.version
        `)
			);
		});
	}

	isPyodideLoaded(): Promise<void> {
		if (this._pyodide) {
			return Promise.resolve();
		}
		return new Promise((resolve, _reject) => {
			this._onPyodideLoaded.push(resolve);
		});
	}

	async run(code: string): Promise<{result: any} | {error: any}> {
		await this.isPyodideLoaded();

		if (this._pyodide) {
			let result: any;
			try {
				result = this._pyodide.runPython(code);
			} catch (e) {
				return {error: e};
			}
			return {result};
		}
		return {error: "Pyodide not loaded"};
	}
}

export const Pyodide = (function () {
	let instance: PythonRunner | null = null;
	function createInstance() {
		const object = new PythonRunner();
		return object;
	}
	return {
		getInstance: function () {
			if (!instance) {
				instance = createInstance();
			}
			return instance;
		},
	};
})();
